import { render, staticRenderFns } from "./TrainerActivityRadar.vue?vue&type=template&id=472806f8&scoped=true"
import script from "./TrainerActivityRadar.vue?vue&type=script&lang=js"
export * from "./TrainerActivityRadar.vue?vue&type=script&lang=js"
import style0 from "./TrainerActivityRadar.vue?vue&type=style&index=0&id=472806f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472806f8",
  null
  
)

export default component.exports